import { useUsageMcpPortfolioQuery } from "@/v2-backoffice-client/usage/mcp/usage.mcpPortfolio.query"
import { MCP_HISTORY_DAYS } from "@/v2-backoffice-client/usage/mcp/usage.mcp.constants"

export type UsePortfolioMcpDataInput = {
  /** One MCP server's app code; the report is one chapter per server. */
  appCode: string
  /**
   * Resolved server-side scope (facets resolved to ids by the caller);
   * null = the whole portfolio.
   */
  customerIds: string[] | null
  excludeCustomerIds: string[]
  excludeUserIds: number[]
}

/**
 * One MCP server's report in one fetch: the key figures, the ISO weeks of
 * the trailing window, the 28-day tool / client / refusal breakdown, one
 * row per customer and every person, all aggregated server-side. Follows
 * the same global customer / user filters as the daily-rows fetch, so the
 * MCP tab describes the same book as the other tabs.
 */
export function usePortfolioMcpData(input: UsePortfolioMcpDataInput) {
  const { appCode, customerIds, excludeCustomerIds, excludeUserIds } = input

  const { data, loading, error } = useUsageMcpPortfolioQuery({
    variables: {
      days: MCP_HISTORY_DAYS,
      appCode,
      customerIds,
      excludeCustomerIds:
        excludeCustomerIds.length > 0 ? excludeCustomerIds : null,
      excludeUserIds: excludeUserIds.length > 0 ? excludeUserIds : null,
    },
  })

  return { mcp: data?.getUsageMcpForPortfolio ?? null, loading, error }
}
